import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';

export function shallowEqual(object1, object2) {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }

    return true;
}

export function logValidationErrors(formControls: { [key: string]: AbstractControl }) {
    return Object.values(formControls).forEach((control: AbstractControl) => {
        if (control instanceof UntypedFormGroup) {
            Object.values(control.controls).forEach(control => control.markAsTouched());
        }

        if (control instanceof UntypedFormArray) {
            for (const controlarray of control.controls) {
                if (controlarray instanceof UntypedFormGroup) {
                    Object.values(controlarray.controls).forEach(control => control.markAsTouched());
                }
            }
        } else {
            control.markAsTouched();
        }
    });
}